// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"xT-z","smallCardRow":"yT-z","largeCardRow":"zT-z","productSearchRow":"AT-z","curatedRow":"BT-z"};